export default "__VITE_ASSET__zi8jWbkq__"